const Promotions = () => {
	return <div>Promotions</div>;
};
export default Promotions;
